"use client";

import { Skeleton } from "../ui/skeleton";

 
export function FeaturedRestaurantsSkeleton() {
  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Skeleton */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-4">
            <Skeleton className="w-16 h-8 rounded-full" />
          </div>
          
          <Skeleton className="h-12 w-64 mx-auto mb-4" />
          <Skeleton className="h-6 w-96 mx-auto" />
        </div>

        {/* Grid Skeleton */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="group relative">
              {/* Card Container */}
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 h-full animate-pulse">
                {/* Image Skeleton */}
                <div className="relative h-48 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200">
                  <div className="absolute top-4 left-4">
                    <Skeleton className="w-20 h-6 rounded-full" />
                  </div>
                  <div className="absolute bottom-4 left-4">
                    <Skeleton className="w-16 h-6 rounded-xl" />
                  </div>
                </div>
                
                {/* Content Skeleton */}
                <div className="p-5">
                  {/* Title & Rating */}
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex-1">
                      <Skeleton className="h-6 w-3/4 mb-2" />
                      <Skeleton className="h-4 w-1/2" />
                    </div>
                    <Skeleton className="w-16 h-8 rounded-xl" />
                  </div>
                  
                  {/* Description */}
                  <Skeleton className="h-4 w-full mb-2" />
                  <Skeleton className="h-4 w-2/3 mb-4" />
                  
                  {/* Tags */}
                  <div className="flex gap-2 mb-4">
                    <Skeleton className="h-6 w-16 rounded-full" />
                    <Skeleton className="h-6 w-20 rounded-full" />
                    <Skeleton className="h-6 w-12 rounded-full" />
                  </div>
                  
                  {/* Features */}
                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <div className="flex gap-4">
                      <Skeleton className="h-4 w-20" />
                      <Skeleton className="h-4 w-16" />
                    </div>
                    <Skeleton className="h-4 w-24" />
                  </div>
                </div>
              </div>
              
              {/* Shimmer Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full animate-shimmer" />
            </div>
          ))}
        </div>

        {/* CTA Skeleton */}
        <div className="text-center">
          <Skeleton className="h-14 w-64 mx-auto rounded-2xl" />
          <Skeleton className="h-4 w-48 mx-auto mt-4" />
        </div>
      </div>
    </section>
  );
}

// Add shimmer animation to globals.css
// Add this to your global CSS file:
/*
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
.animate-shimmer {
  animation: shimmer 1.5s infinite;
}
*/